import state from "./teamState";
import mutations from "./teamMutations";
import getters from "./teamGetters";
import actions from "./teamActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
